module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAJ1BMVEUAfjpQpnjYRzPa7OLiemz44d0AfjpUqHt+XTaoknj8PTL9fXb///+p7wVgAAAABnRSTlPU4Pj4+v6DjlR7AAAAQklEQVRIx+3LMQ0AIAxFwWrBAcEKWEBLtWCEEBDFXoYf9nf7WQtqUuwEeygUCoVCofyX5cpTZlcoFAqFQtGlBNmUCxaq8SKFhMz7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/mg.png
// module id = 24zR
// module chunks = 0